import React from "react";
import { ChartNoAxesColumn, ShieldCheck } from "lucide-react";
import { Button } from "../ui/button";
import { useTheme } from "../../theme";
import { GameSettingsPopover } from './GameSettingsPopover';

export const KenoToolbar = ({ onView, game }) => {
  const { theme } = useTheme();
  return (
  <footer className="keno-toolbar" data-testid="keno-toolbar">
    <div className="keno-tools">
      <GameSettingsPopover game={game} onInfo={() => onView('info')} />
      <Button variant="ghost" size="icon" onClick={() => onView("stats")} data-testid="keno-stats" aria-label="Recent rounds and statistics" title="Recent rounds"><ChartNoAxesColumn size={18} data-testid="keno-toolbar-stats-icon" aria-hidden="true" /></Button>
    </div>
    <img className="keno-brand" data-testid="keno-footer-brand" src={theme !== "venom" ? "/gv-logo-onyx.png" : "/gv-logo.png"} alt="GVRewards" />
    <Button onClick={() => onView("fairness")} data-testid="keno-fairness" aria-label="Fairness" title="Fairness" className="keno-secondary keno-fairness-button"><ShieldCheck size={17} /><span>Fairness</span></Button>
  </footer>
  );
};